import { css } from '@emotion/react';

export function onClick(p) {
    return (
        p.onClick &&
        css`
            cursor: pointer;
            &:hover,
            &:focus {
                opacity: 0.7;
            }
        `
    );
}

export const widthProp = (props) => (props.width ? { width: `${props.width}px` } : null);
export const flexProp = (props) => (props.flex ? { flex: props.flex } : null);
export const onClickProp = (p) =>
    p.onClick &&
    css`
        cursor: pointer;
        &:hover,
        &:focus {
            opacity: 0.7;
        }
    `;

export const fontSizeProp = (props) => (props.fontSize ? { fontSize: props.theme.fontSize[props.fontSize] } : null);

export const sizeProp = ({ size }) =>
    size
        ? {
              width: size,
              height: size,
          }
        : null;

export const maxSizeDesktop = (props) => `@media (max-width: ${props.theme.breakpoint.desktop}px)`;
export const maxSizeMedium = (props) => `@media (max-width: ${props.theme.breakpoint.medium}px)`;
export const maxSizeTablet = (props) => `@media (max-width: ${props.theme.breakpoint.tablet}px)`;
export const maxSizePhone = (props) => `@media (max-width: ${props.theme.breakpoint.phone}px)`;

export const spacingExtraSmall = (props) => props.theme.padding.extraSmall;
export const spacingSmall = (props) => props.theme.padding.small;
export const spacingMedium = (props) => props.theme.padding.medium;
export const spacingExtraLarge = (props) => props.theme.padding.extraLarge;
export const spacingHuge = (props) => props.theme.padding.huge;
